import { formatDateTime } from '~/lib/DateTime.js';
import { useContext, useEffect, useState } from 'react';
import * as ClientApi from '~/lib/ClientApi';
import { FormContext } from '~/components/forms/FormContext';
import usePrefillClientForm from '~/public/lib/usePrefillClientForm';
import Select from '~/components/Select';
import Modal from '~/components/Modal';
import Loading from '~/components/Loading';
import ClientAccountManageModal from '~/components/forms/questions/components/ClientAccountManageModal';
import { clearPublicQueries } from '~/public/lib/PublicQueries.js';

const ClientAccountIsLoggedIn = ({ clientUser, data }) => {
    const { form, submission } = useContext(FormContext);
    const [currentClient, setCurrentClient] = useState(null);
    const [isManageOpen, setIsManageOpen] = useState(false);

    const { setClient: setPrefillClient } = usePrefillClientForm(
        submission?.formData,
        submission?.setFormData,
        form?.id,
    );

    const allClients = data?.clients || [];

    function setClient(client) {
        if (client?.id !== currentClient?.id) {
            setCurrentClient(client);
            setPrefillClient(client);
        }
    }

    function logout() {
        ClientApi.get('/account/logout');
        ClientApi.setToken(null);
        clearPublicQueries();
    }

    useEffect(() => {
        if (allClients.length) {
            setClient(allClients[0]);
        }
    }, [JSON.stringify(data?.clients)]);

    const clientOptions = {};
    allClients.forEach(c => (clientOptions[c.id] = c.name));

    return (
        <div className="sm:flex justify-between sm:space-x-4">
            <div className="flex-1">
                {allClients.length > 1 && (
                    <div>
                        <Select
                            value={currentClient?.id}
                            onChange={newClientId => {
                                setClient(
                                    allClients.find(
                                        c =>
                                            parseInt(c.id) ===
                                            parseInt(newClientId),
                                    ),
                                );
                            }}
                            options={clientOptions}
                        />
                    </div>
                )}
                {allClients.length <= 1 && (
                    <div>
                        <div className="bg-gray-200 rounded-lg px-4 py-2">
                            {allClients[0]?.name || clientUser.email}
                        </div>
                    </div>
                )}

                <div
                    className={`text-gray-500 text-xs mt-2 flex items-center justify-between`}
                >
                    <div>
                        Logged in as <span>{clientUser.email}</span>
                    </div>
                    <button
                        className="underline ml-2 mr-2 text-gray-500"
                        type="button"
                        onClick={logout}
                    >
                        Log out
                    </button>
                </div>
            </div>
            <div className="flex-1 flex items-start mt-4 sm:mt-0 space-x-4">
                <button
                    type="button"
                    className="form-button btn-small"
                    onClick={() => setIsManageOpen(true)}
                >
                    My Account
                </button>
                <ClientAccountManageModal
                    isOpen={isManageOpen}
                    onClose={() => setIsManageOpen(false)}
                    client={currentClient}
                    allClients={allClients}
                    form={form}
                />
            </div>
        </div>
    );
};

export default ClientAccountIsLoggedIn;
